import { useCallback, useEffect, useRef, useState } from "react";

// Houdt de oude volgorde van de ranglijsten vast tot er een "rank-up" loopt,
// zodat de wissel niet voor de aankondiging uit loopt. Na settleMs rust, of
// bij een nieuwe naam, komt de nieuwe lijst alsnog.
// settle(data): meteen deze cijfers tonen, zonder vasthouden (voor het lab).

const settleMs = 1500;

const orderOf = (list = []) => list.map((row) => row.name).join("\n");
const listsOf = (data) => ({ rankList: data.rankList, yearRankList: data.yearRankList });

export function useHeldRanking(data, active) {
  const shown = useRef(listsOf(data));
  const release = useRef(false);
  const [, rerender] = useState(0);

  const known = new Set(shown.current.rankList.map((row) => row.name));
  const newcomer = data.rankList.some((row) => !known.has(row.name));
  const sameOrder = orderOf(data.rankList) === orderOf(shown.current.rankList);
  const climbing = active.some((run) => run.id === "rank-up");

  if (sameOrder || newcomer || climbing || release.current) {
    shown.current = listsOf(data);
    release.current = false;
  }

  const settle = useCallback((next) => {
    shown.current = listsOf(next);
    release.current = false;
    rerender((count) => count + 1);
  }, []);

  const holding = shown.current.rankList !== data.rankList;
  const idle = active.length === 0;

  useEffect(() => {
    if (!holding || !idle) return undefined;
    const timer = setTimeout(() => {
      release.current = true;
      rerender((count) => count + 1);
    }, settleMs);
    return () => clearTimeout(timer);
  }, [holding, idle]);

  return { ...shown.current, settle };
}
